import Component from "./anonSurvey.component";
import { Config } from "./anonSurvey.config";
import { watchAnonSurvey as saga } from "./redux/anonSurvey.sagas";
import { reducer } from "./redux/anonSurvey.reducer";

export default { Component, saga, reducer, config: Config };
